// Chakra imports
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import InvitationsTableRow from "./InvitationsTableRow.js";
import React from "react";
import { FiMail } from "react-icons/fi";

const InvitationsTable = ({ title, captions, data, setInvitations }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const count = data ? data.length : 0;

  return (
    <Card my='22px' overflowX={{ base: "auto", xl: "hidden" }}>
      <CardHeader p='6px 0px 18px 0px'>
        <Flex align='center' justify='space-between'>
          <Text fontSize='xl' color={textColor} fontWeight='bold'>
            {title}
          </Text>
          <Text fontSize='sm' color='gray.400' fontWeight='normal'>
            {count} {count === 1 ? "invitation" : "invitations"} recorded
          </Text>
        </Flex>
      </CardHeader>
      <CardBody>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr my='.8rem' pl='0px' color='gray.400'>
              {captions.map((caption, idx) => {
                return (
                  <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                    {caption}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {data && data.length > 0 ? (
              data.map((row) => {
                return (
                  <InvitationsTableRow
                    key={`${row.email}`}
                    email={row.email}
                    expiration_time={row.expiration_time}
                    is_registered={row.is_registered}
                    CreatedAt={row.CreatedAt}
                    setInvitations={setInvitations}
                  />
                );
              })
            ) : (
              <Tr>
                <Td colSpan={captions.length} textAlign='center' py='36px'>
                  <Flex direction='column' align='center' justify='center' gap='8px'>
                    <Icon as={FiMail} w='32px' h='32px' color='gray.300' />
                    <Text fontSize='sm' color='gray.400' fontWeight='medium'>
                      No invitations issued yet.
                    </Text>
                    <Text fontSize='xs' color='gray.400'>
                      Enter an email address above to dispatch the first invitation.
                    </Text>
                  </Flex>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default InvitationsTable;
